export default {
  VITE_GTM_ID: "VITE_GTM_ID",
  NO_VALUE: "NO_VALUE",
};
